import React from 'react'
import { Form, Input } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './CustomPasswordInput.module.scss'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'

const CustomPasswordInput = (props: any) => {
  const { name, required = false, placeholder } = props
  const { t } = useTranslation()

  return (
    <>
      <Form.Item
        name={name}
        rules={[
          { required, message: t('general.RequiredValidation'), whitespace: true },
          {
            pattern: /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
            message: t('Projects.NoValidPassword'),
          }
        ]}
      >
        <Input.Password
          placeholder={placeholder}
          size='large'
          className={styles['custom-password-input']}
          iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        />
      </Form.Item>
    </>
  )
}

export default CustomPasswordInput
